<style lang="sass" scoped>
.pagination > li > a, .pagination > li > span {
  width: 42px;
  text-align: center;
}
</style>


<template>
<div id="pagination-{{ _uid }}" v-if="pageCount > 1">
  <nav aria-label="Page navigation">
    <ul class="pagination">
      <template v-if="pageCount > chunkSize">
      <li v-if="chunkHead == 1" class="disabled">
          <span><span aria-hidden="true">&laquo;</span></span>
      </li>
      <li v-else>
        <a href="#" aria-label="Previous" @click.prevent="chunkHead -= 1">
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>
      </template>

      <li v-for="i in chunk" v-bind:class="{active: page == i.page}">
        <a href="#" @click.prevent="page = i.page">{{ i.page }}</a>
      </li>

      <template v-if="pageCount > chunkSize">
      <li v-if="chunkTail == pageCount" class="disabled">
        <span><span aria-hidden="true">&raquo;</span></span>
      </li>
      <li v-else>
        <a href="#" aria-label="Next" @click.prevent="chunkHead += 1">
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
      </template>
    </ul>
  </nav>
</div>
</template>


<script>
export default {
  name: 'ui-pagination',
  props: {
    page: {
      type: Number,
      required: true,
    },
    pageCount: {
      type: Number,
      required: true,
    },
    chunkSize: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      chunkHead: 1,
    }
  },
  computed: {
    offset() {
      let offset = Math.floor(this.chunkLength / 2) - 1
      return this.page - offset > 0 ? offset : this.page - 1
    },
    chunkLength() {
      return Math.min(this.pageCount, this.chunkSize)
    },
    chunkTail() {
      return this.chunkHead + this.chunkLength - 1
    },
    chunk() {
      let chunk = []
      for (var i = this.chunkHead; i <= this.chunkTail; i++) {
        chunk.push({
          page: i,
        })
      }
      return chunk
    },
  },
  ready() {
    this.chunkHead = this.page
  },
}
</script>


// WEBPACK FOOTER //
// pagination.vue?58c83c32